import InfoTable from "../../../common/components/InfoTable"
import { getConfig } from "../../../config"
import { colorName } from "../../../helpers"
import Header from "../components/micro/Header"
import { Info } from "../components/micro/Info"
import { List } from "../components/micro/List"
import { Next } from "../components/micro/Next"
import { Page } from "../components/micro/Page"
import { Table } from "../components/micro/Table"
import { Tag } from "../components/micro/Tag"
import Topbar from "../components/micro/Topbar"
import { Tr } from "../components/micro/Tr"

export function CampionePage({
    onBack,
    lv0, lv1, lv2, lv3,
    listLv4,
    hoverLv4,
    onMouseEnterRow,
    onMouseLeaveRow,
    onClickRow
}) {
    return (
        <Page>
            <Topbar onBack={onBack}>Campioni</Topbar>
            <Header
                lv0={lv0 ? lv0.nome : null}
                lv1={lv1 ? lv1.siglaMacrolotto + (lv1.descrizione ? " - " + lv1.descrizione : "") : null}
                lv2={lv2 ? lv2.nome : null}
                lv3={lv3 ? lv3.siglaSondaggio : null}
                lv3color={lv3 ? colorName(lv3.coloreSondaggio) : null}
            />
            <List>
                <Table>
                    <thead>
                        <tr>
                            <th>Sigla campione</th>
                            <th>Profondità da - a</th>
                            <th>Codice CESI</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {listLv4 ? listLv4.map((campione, i) =>
                            <Tr
                                key={i}
                                color={colorName(campione.coloreCampione)}
                                onMouseEnter={() => onMouseEnterRow(campione)}
                                onMouseLeave={() => onMouseLeaveRow()}
                                onClick={() => onClickRow(campione)}
                                isHover={hoverLv4 && hoverLv4.id === campione.id}
                            >
                                <td>{campione.siglaCampione}</td>
                                <td>{campione.prof_da} - {campione.prof_a}</td>
                                <td>
                                    {campione.codice_cesi}
                                    {campione.document_t ?
                                        <a onClick={(e) => { e.stopPropagation() }} href={getConfig("defaultBucketUrl") + campione.document_t} target="_blank" rel="noreferrer"><Info label="Rapporto di prova Terreno"><Tag>RDP T</Tag></Info></a>
                                        : null}
                                    {campione.document_e ?
                                        <a onClick={(e) => { e.stopPropagation() }} href={getConfig("defaultBucketUrl") + campione.document_e} target="_blank" rel="noreferrer"><Info label="Rapporto di prova Eluato"><Tag>RDP E</Tag></Info></a>
                                        : null}
                                </td>
                                <td>{campione.has_eluato ? <Info label="Eluato">E</Info> : null}</td>
                                <td>
                                    {campione.litologia || campione.unita_di_fondo || campione.nota ?
                                        <InfoTable
                                            columns={["Litologia", "Unità di fondo", "Nota"]}
                                            values={[[campione.litologia, campione.unita_di_fondo, campione.nota]]}
                                        />
                                        : null}
                                </td>
                                <Next><i className="fas fa-chevron-right"></i></Next>
                            </Tr>
                        ) : null}
                    </tbody>
                </Table>
            </List>
        </Page>
    )
}